import React from "react";
import { Link, StaticQuery, graphql } from "gatsby";
import { Post, Project } from "../types";
import Mastodon from "../img/mastodon.svg";
import PatreonIcon from "../img/patreon.svg";

const Footer = () => (
  <StaticQuery
    query={footerQuery}
    render={(data) => {
      const posts = data.allMarkdownRemark.edges;
      const projects = data.allProjectsJson.edges;

      return (
        <footer className="footer">
          <div className="footer__container">
            <div className="shiny footer__links">
              <h2>Shiny stuff</h2>
              <ul>
                {projects.map(({ node }: { node: Project }) => (
                  <li key={node.id}>
                    <a href={node.url} title={node.name}>
                      {node.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="wordy footer__links">
              <h2>Wordy stuff</h2>
              <ul>
                {posts.map(({ node }: { node: Post }) => {
                  const title = node
                    ? node.frontmatter.title || node.fields.slug
                    : null;
                  return (
                    <li key={node.fields.slug}>
                      <Link to={`/blether${node.fields.slug}`}>{title}</Link>
                    </li>
                  );
                })}
              </ul>
            </div>

            <div className="social footer__links">
              <h2>Social stuff</h2>
              <ul>
                <li>
                  <a
                    href="https://github.com/whostolemyhat"
                    title="Have a look at my code on Github"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="icon-github" />
                    Github
                  </a>
                </li>
                <li>
                  <a
                    href="http://uk.linkedin.com/pub/james-tease/32/8a0/b04"
                    title="Also on LinkedIn"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="icon-linkedin" />
                    LinkedIn
                  </a>
                </li>
                <li>
                  <a
                    rel="me noopener noreferrer"
                    href="https://mastodon.social/@whostolemyhat"
                    title="whostolemyhat on Mastodon"
                    target="_blank"
                  >
                    <Mastodon />
                    Mastodon
                  </a>
                </li>
             </ul>
            </div>
          </div>
        </footer>
      );
    }}
  />
);
// }

const footerQuery = graphql`
  query FooterQuery {
    allProjectsJson(sort: { date: DESC }, limit: 3) {
      edges {
        node {
          id
          url
          name
        }
      }
    }

    allMarkdownRemark(limit: 3, sort: { frontmatter: { date: DESC } }) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
          }
        }
      }
    }

    site {
      siteMetadata {
        author
        social {
          twitter
        }
      }
    }
  }
`;

export default Footer;
